import { render, staticRenderFns } from "./DiscountBox.vue?vue&type=template&id=0f2492d0"
import script from "./DiscountBox.vue?vue&type=script&lang=js"
export * from "./DiscountBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports